<template>
	<div style="width: 150px;" class="mr-1 d-flex-column" >
		<v-text-field v-model="studentName" 
		@input="nameInputHandler" 
		@compositionstart="isCompositon"
		@compositionend="compositonEnd"
		label="学员姓名" dense outlined></v-text-field>
		<div style="position: relative;" ref="selectDiv">
			<ul class="studentResult">
				<li v-for="(item,index) in nameList" :key="index" @click="selectedStudent(item)">{{item}}</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import debounce from "../config/debounce.js"
	import utils from "../config/utils.js"
	export default {
		name: "student-search-box",
		data() {
			return{
				studentName:"",
				isInputing:false,
				delayInvokeName:null,
				nameList:[],
				divDom:null,
				signalFetch:utils.cancelAndFetch(), // 下个请求会取消上一个请求，防止请求乱序
			}
			
		},
		created() {
			// 防抖
			this.delayInvokeName = debounce(this.getStudentListByName,500);
		},
		mounted() {
			this.divDom = this.$refs.selectDiv;
			const that= this;
			document.addEventListener('click', function(event) {
				
			  // 获取点击的目标元素
			  var target = event.target;
			  
			  // 判断点击的目标是否是搜索框或搜索结果区域
			  if (target !== that.divDom) {
			    that.divDom.style.display = 'none'; // 点击其他地方时收起搜索结果
			  }
			});
		},
		watch:{
			studentName(newValue,oldValue){
				
				this.$emit("inputValue",newValue);
			}
		},
		methods:{
			isCompositon(e){
				// 正在合成拼音
				this.isInputing = true;
			},
			compositonEnd(e){
				// 拼音合成结束
				this.isInputing = false;
				// 合成结束调用api，因为会先回调input 再回调合成结束
				this.delayInvokeName(this.studentName);
			},
			nameInputHandler(e){
				
				if(this.isInputing){
					return;
				}
				
				// 调用api
				this.delayInvokeName(e)
		
			},
			getStudentListByName(keyword){
				if(!keyword){
					return
				}
				// 获取学生列表
		
				const shopId = utils.getCurrentShopId();
				
				let url = `/edu/student/list/${shopId}/${keyword}?v=1`;
				const that = this;
				// 会取消之前的请求
				this.signalFetch(url).then(data => {

					const resData = data.data;
					
					const stuList = resData.data || [];
					
					that.nameList = stuList.map((item)=>item.studentName)
					if(that.nameList){
						 that.divDom.style.display = ''; 
					}
					
					
				}).catch(err=>{
					console.log("err:",err.message)
				})
				
			},
			selectedStudent(studentName){
				this.studentName = studentName;
			},
		}
	}
</script>

<style scoped>
	.studentResult{
		position: absolute;
		top:-26px;
		left:0;
		list-style: none;
		background-color: lightblue;
		width: 180px;
		max-height:200px;
		overflow: hidden auto;
		border-radius: 10px;
	}
	.studentResult li{
		display:block;
		height:30px;
		line-height: 30px;
		cursor: pointer;
	}
</style>
